/**
 * BusinessPartner（取引先）Overview — Frontend ローカル Contract（ステータス別 / ロール別 / タイプ別）
 *
 * BE 側 `dresscode-backend/v2/src/business-central/api/business-partner-overview/usecase/business-partner-overview.api-contract.ts`
 * と同じ Zod 構造を再現。BE が `@standandforce/api-contract` に publish された後、
 * client.ts でローカル import を置き換える想定。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const BusinessPartnerOverviewTypeSchema = z.enum(['CORPORATION', 'INDIVIDUAL']);
const BusinessPartnerOverviewRoleSchema = z.enum(['CUSTOMER', 'SUPPLIER', 'FINANCIAL_INSTITUTION', 'RESELLER_AGENT', 'EMPLOYEE']);
const BusinessPartnerOverviewEventTypeSchema = z.enum(['BUSINESS_PARTNER_CREATED', 'BUSINESS_PARTNER_UPDATED', 'BUSINESS_PARTNER_CSV_IMPORT_CREATED', 'BUSINESS_PARTNER_CSV_IMPORT_UPDATED']);
const BusinessPartnerOverviewStatusSchema = z.enum(['DRAFT', 'PENDING_APPROVAL', 'REJECTED', 'ACTIVE', 'UNDER_REVIEW', 'SUSPENDED', 'TERMINATED']);
const RoleCountSchema = z.object({
  role: BusinessPartnerOverviewRoleSchema,
  count: z.number()
});
const TypeCountSchema = z.object({
  type: BusinessPartnerOverviewTypeSchema,
  count: z.number()
});
const StatusCountSchema = z.object({
  status: BusinessPartnerOverviewStatusSchema,
  count: z.number()
});
const BusinessPartnerOverviewCountSchema = z.object({
  total: z.number(),
  recentPartners: z.array(z.object({
    businessPartnerId: z.string(),
    name: z.string()
  })),
  statusCounts: z.array(StatusCountSchema),
  roleCounts: z.array(RoleCountSchema),
  typeCounts: z.array(TypeCountSchema)
});
const BusinessPartnerOverviewActivityItemSchema = z.object({
  businessPartnerId: z.string(),
  name: z.string(),
  eventType: BusinessPartnerOverviewEventTypeSchema,
  occurredAt: z.string()
});
const BusinessPartnerOverviewActivitySchema = z.object({
  items: z.array(BusinessPartnerOverviewActivityItemSchema)
});
export const businessPartnerOverviewContract = oc.router({
  count: oc.route({
    method: 'GET',
    path: '/v2/business-partner-ledger/overview/count'
  }).output(BusinessPartnerOverviewCountSchema),
  activity: oc.route({
    method: 'GET',
    path: '/v2/business-partner-ledger/overview/activity'
  }).output(BusinessPartnerOverviewActivitySchema)
});
export type BusinessPartnerOverviewType = z.infer<typeof BusinessPartnerOverviewTypeSchema>;
export type BusinessPartnerOverviewRole = z.infer<typeof BusinessPartnerOverviewRoleSchema>;
export type BusinessPartnerOverviewStatus = z.infer<typeof BusinessPartnerOverviewStatusSchema>;
export type BusinessPartnerOverviewCount = z.infer<typeof BusinessPartnerOverviewCountSchema>;
export type BusinessPartnerOverviewActivityItem = z.infer<typeof BusinessPartnerOverviewActivityItemSchema>;